
export default {
  namespaced: true,
  state: {
    // 用户信息
    pagesParam: {
      paySum: {},
      collectMoneySum: {},
      fundChangeSum: {},
      dailyPaper: {}
    }
  },
  actions: {
    set({ state, dispatch }, param) {
      state.pagesParam[param.type] = param
    }
  }
}
